import { render, staticRenderFns } from "./DocumentBanner.vue?vue&type=template&id=e40ab5b4&"
import script from "./DocumentBanner.vue?vue&type=script&lang=ts&"
export * from "./DocumentBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports